import { formatCurrency } from '../../utils/CommonUtils';

const GROUP_TYPES = ['PRODUCT_GROUP', 'SERVICE_GROUP'];

/**
 * Плитка каталогу — або категорія, або конкретна позиція.
 *
 * Було: квадрат із `padding-top: 120%` і абсолютно спозиційованим вмістом,
 * через що назва товару, кількість і ціна накладалися одне на одне на
 * вузьких екранах, а довгі назви «лікувалися» зменшенням шрифту.
 * Стало: flex-колонка з фіксованою мінімальною висотою й обрізанням
 * назви за двома рядками.
 */
const CatalogTile = ({ item, onOpenGroup, onAdd }) => {
    const isGroup = GROUP_TYPES.includes(item.item_type);

    if (isGroup) {
        return (
            <button
                type="button"
                className="rc-catalog-tile rc-catalog-tile--group"
                onClick={() => onOpenGroup(item)}
            >
                <span className="rc-catalog-tile__media">
                    <i className="pi pi-folder" />
                </span>
                <span className="rc-catalog-tile__name">{item.name}</span>
                <span className="rc-catalog-tile__meta">Категорія</span>
            </button>
        );
    }

    return (
        <button type="button" className="rc-catalog-tile" onClick={() => onAdd(item)}>
            {/* Без картинки плейсхолдер показуємо лише на десктопі (клас
                --empty ховає його на телефоні): там плитка низька і місце
                під зображення з'їдало б назву, а на великих плитках без
                нього лишається порожня діра посередині. */}
            <span
                className={`rc-catalog-tile__media ${
                    item.logo ? '' : 'rc-catalog-tile__media--empty'
                }`.trim()}
                style={item.logo ? { backgroundImage: `url(${item.logo})` } : undefined}
            >
                {!item.logo && <i className="pi pi-image" />}
            </span>
            <span className="rc-catalog-tile__name">{item.name}</span>
            {item.product_identifier ? (
                <span className="rc-catalog-tile__meta">IMEI {item.product_identifier}</span>
            ) : (
                item.quantity !== undefined &&
                item.quantity !== null && (
                    <span className="rc-catalog-tile__meta">Залишок: {item.quantity}</span>
                )
            )}
            <span className="rc-catalog-tile__price">
                {formatCurrency(item.price, item.currency ?? 'UAH')}
            </span>
        </button>
    );
};

export default CatalogTile;
